import { useTheme } from '@fable/theme'

const PlayIcon: React.VFC<{ isNew?: boolean; color?: string }> = ({
  isNew = false,
  color,
}) => {
  const { colors } = useTheme()

  if (isNew) {
    return (
      <svg
        className="fds-ui--icon fds-ui--play-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 28"
      >
        <path
          fill="#fff"
          d="M14,0A14,14,0,1,0,28,14,14,14,0,0,0,14,0Zm6.84,15-.17.11c-.84.45-7.38,4-8.38,4.62s-2.29.2-2.29-.74V9.06c0-.93,1.18-1.4,2.23-.79l.12.07c.71.38,7.79,4.15,8.5,4.6A1.19,1.19,0,0,1,20.84,15Z"
        />
      </svg>
    )
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 38"
      className="play-icon"
    >
      <path
        fill={color ? color : colors.blackSwan}
        d="M19,0A19,19,0,1,0,38,19,19,19,0,0,0,19,0ZM15.2,25.65V12.35a1,1,0,0,1,1.52-.76l8.87,6.65a.94.94,0,0,1,0,1.52l-8.87,6.65A1,1,0,0,1,15.2,25.65Z"
      />
    </svg>
  )
}

export default PlayIcon
